const {MODIFY_NGO_LIMITS_INFO_SUCCESS, MODIFY_NGO_LIMITS_INFO_FAILURE} = require('constants/contactCenter/actionTypes');

const setInfoSuccess = () => ({
    type: MODIFY_NGO_LIMITS_INFO_SUCCESS
});

const setInfoFailure = () => ({
    type: MODIFY_NGO_LIMITS_INFO_FAILURE
});

module.exports = {
    setInfoSuccess,
    setInfoFailure
}
